import * as d3 from 'd3'
import { ChartLinesProps } from '../interface'
import {
  GreenGrad,
  GrayGrad,
  BlueGrad,
  BlueGradHorizontal,
  RedGrad,
  RedGradHorizontal,
  MiddleLineGradient,
} from '../Gradients'
import { AppendText } from './AppendText'

export const ChartLines = ({
  verticalPos,
  heightTop,
  heightBottom,
  horizontalPos,
  curValue,
  width,
  height,
  animate,
  min,
  max,
}: ChartLinesProps) => {
  const yScale = d3
    .scaleLinear()
    .domain([min, max]) // input
    .range([50, height - 50]) // output
  const middleLine = yScale(curValue)

  const svg = d3
    .select('.chart')
    .append('svg')
    .attr('width', width)
    .attr('height', height)

  BlueGrad(svg, animate)
  BlueGradHorizontal(svg, animate)
  RedGrad(svg, animate)
  RedGradHorizontal(svg, animate)
  MiddleLineGradient(svg)
  GreenGrad(svg)
  GrayGrad(svg)

  svg.append('g').attr('class', 'verticalGrid')
  svg.append('g').attr('class', 'horizontalGrid')
  verticalPos.forEach((i: any) => {
    svg
      .select('.verticalGrid')
      .append('rect')
      .attr('class', 'stroke')
      .attr('x', i)
      .attr('y', 0)
      .attr('rx', 4)
      .attr('width', '0.1px')
      .attr('height', heightTop)
      .attr('stroke', 'url(#blueGrad)')
      .attr('fill', 'none')

    svg
      .select('.verticalGrid')
      .append('rect')
      .attr('class', 'stroke')
      .attr('x', i)
      .attr('y', heightTop)
      .attr('rx', 4)
      .attr('width', '0.1px')
      .attr('height', heightBottom)
      .attr('stroke', 'url(#redGrad)')
      .attr('fill', 'none')
  })

  // horizontal blue gradient grid
  horizontalPos.forEach((i: any) => {
    if (middleLine !== i) {
      svg
        .select('.horizontalGrid')
        .append('rect')
        .attr('class', 'stroke')
        .attr('x', 0)
        .attr('y', i)
        .attr('rx', 4)
        .attr('width', width)
        .attr('height', '0.1px')
        .attr('stroke', 'rgba(52, 52, 64, 0.65)')
        .attr('fill', 'none')
    }
  })

  horizontalPos.forEach((i: any) => {
    if (middleLine !== i) {
      svg
        .select('.horizontalGrid')
        .append('rect')
        .attr('class', 'stroke')
        .attr('x', 0)
        .attr('y', i)
        .attr('rx', 4)
        .attr('width', width)
        .attr('height', '0.1px')
        .attr(
          'stroke',
          height - middleLine > i
            ? 'url(#blueGradHorizontal)'
            : 'url(#redGradHorizontal)',
        )
        .attr('fill', 'none')
    }
  })

  // remove default ticks and axis
  svg.selectAll('text').remove()
  svg.selectAll('.domain').remove()
  svg.selectAll('.grid').select('.tick').remove()

  // middle line
  svg.append('rect').attr('class', 'middleLine')
  d3.select('.middleLine')
    .attr('x', 0)
    .attr('y', heightTop)
    .attr('rx', 4)
    .attr('width', width)
    .attr('height', '0.1px')
    .attr('stroke', 'url(#gradient)')
    .attr('fill', 'none')

  AppendText({ svg, width, heightTop, curValue })
  svg.append('g').attr('class', 'candles')
}
